import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { UpdateFirmOfficePayload } from 'src/app/Models/commonDetail';

interface AccountingFirms {
  accountingFirmId: number;
  firmName: string;
}

@Injectable({
    providedIn: 'root'
})

export class FirmDetailService {
  headers: HttpHeaders = new HttpHeaders();
  private firmOfficePermissionSubject = new BehaviorSubject<boolean>(false);
  firmOfficePermission$ = this.firmOfficePermissionSubject.asObservable();

  constructor(
    private http: HttpClient) { }

  addEditFirmDetail(data) {
    const headers: HttpHeaders = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    return this.http.post<any>('AccountingFirm/AddEditFirmDetail', data,{ headers: headers });
  }

  updateJobCategory(firmDetailId, debtorJobCategory, relatedJobCategory) {
    return this.http.post<any>(`AccountingFirm/UpdateFirmJobCategory?firmDetailId=${firmDetailId}&debtorJobCategory=${debtorJobCategory}&relatedJobCategory=${relatedJobCategory}`, { headers: this.headers });
  }

  updateWorkFlowSetting(firmDetailId: number, flag: boolean) {
    return this.http.post<any>(`AccountingFirm/UpdateFirmWorkflowTeam?firmDetailId=${firmDetailId}&IsModifyTeamInJob=${flag}`, { headers: this.headers });
  }

  updateInvoiceApprovalSettings(firmDetailId: number, isInvoiceApproval: boolean, approvalCount: number, reviewerCount: number) {
    return this.http.post<any>(`AccountingFirm/UpdateInvoiceApprovalReviewerCount?FirmDetailId=${firmDetailId}&IsInvoiveApproval=${isInvoiceApproval}&ApproverCount=${approvalCount}&ReviewerCount=${reviewerCount}`, { headers: this.headers });
  }

  updateBpaySettings(firmDetailId: number, isBpayEnable: boolean, bpayAlgorithm: number, billerCode: string, bpayReferenceType: number) {
    return this.http.post<any>(`AccountingFirm/UpdateBpaySettings?FirmDetailId=${firmDetailId}&IsBpayEnable=${isBpayEnable}&BpayAlgorithm=${bpayAlgorithm}&BillerCode=${billerCode}&BpayReferenceType=${bpayReferenceType}`, { headers: this.headers });
  }

  UpdateInvoiceEmailBody(data) {
    return this.http.post<any>('AccountingFirm/UpdateInvoiceEmailBody', data, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  getFirmDetailsById() {
    return this.http.get<any>('AccountingFirm/GetFirmDetailsById');
  }

  getFirmDetails() {
    return this.http.get<any>('AccountingFirm/GetFirmDetails');
  }

  postEditFirmClientGroup(firmDetailId, _flag) {
    return this.http.post<any>('AccountingFirm/PostEditFirmClientGroup?firmDetailId=' + firmDetailId + '&isTrackIndividually=' + _flag + '', { headers: this.headers });
  }

  updateFirmClientMode(firmDetailId, flag) {
    return this.http.post<any>('AccountingFirm/UpdateFirmClientMode?firmDetailId='+ firmDetailId +'&isAutoMode='+ flag +'', { headers: this.headers });
  }

  postEditTimesheetdailyweekly(firmDetailId, type, flag) {
    return this.http.post<any>('AccountingFirm/PostEditTimesheetdailyweekly?firmDetailId=' + firmDetailId + '&typeradio=' + type + '&istimesheetdailyweekly=' + flag + '', { headers: this.headers });
  }

  updateunitPostEditTimesheetdailyweekly(firmDetailId,value) {
    return this.http.post<any>('AccountingFirm/UpdateunitPostEditTimesheetdailyweekly?firmDetailId=' + firmDetailId  + '&unitvalue=' + value + '', { headers: this.headers });
  }

  updateInvoiceDueDateGSTSubTotal(firmDetailId,textGSRBy,GSTSubTotal) {
    return this.http.post<any>('AccountingFirm/UpdateInvoiceDueDateGSTSubTotal?FirmDetailId=' + firmDetailId + '&InvoiceDueDate=' + textGSRBy + '&GSTSubTotal=' + GSTSubTotal + '', { headers: this.headers });
  }

  getAccountingFirms() {
    return this.http.get<AccountingFirms[]>('AccountingFirm/GetAccountingFirms');
  }

  GetPracticesList() {
    return this.http.get<any>('AccountingFirm/GetPracticesList');
  }

  GetPracticesCountByUseremail() {
    return this.http.post<any>('AccountingFirm/GetPracticesCountByUseremail', { headers: this.headers });
  }

  Updatefavorite(id, tenants, useremail) {
    return this.http.get<any>('AccountingFirm/Updatefavorite?id=' + id + '&tenants=' + tenants + '&useremail=' + useremail);
  }

  GetFirmTimeSheetSettingById() {
    return this.http.get<any>('AccountingFirm/GetFirmTimeSheetSettingById/');
  }

  GetPlanningSettings(){
    return this.http.get<any>('AccountingFirm/GetFirmPlanningAreaSettings');
  }

  updateInvoiceAdjAmount(amount: number) {
    const headers: HttpHeaders = new HttpHeaders();
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post<any>(`AccountingFirm/UpdateFirmInvoiceAdjustmentUpToAmount?amount=${amount}`, { headers: headers });
  }

  updateFirmOffice(payload: UpdateFirmOfficePayload) {
    return this.http.post<any>(`AccountingFirm/UpdateFirmOffice?firmDetailId=${payload.firmDetailId}&canEnableOffice=${payload.canEnableOffice}`,{ headers: this.headers });
  }

  // Method to update the permission value for firm office
  setFirmOfficePermission(value: boolean): void {
      this.firmOfficePermissionSubject.next(value);
  }

  updateStaffBudgetFrequency(data) {
    return this.http.post<any>('AccountingFirm/AddUpdateStaffBudgetFrequencySettings', data, { headers: this.headers });
  }

  GetFirmDetailsBy() {
    return this.http.get<any>('AccountingFirm/GetFirmDetailsBy');
  }
}
